import { AffiliateCommissionType, CommissionType } from '../@types';

export const COMMISSION_TYPES = {
  POSITION: 'POSITION',
  PROFIT: 'PROFIT',
  PER_PICK: 'PER_PICK',
  CPA: 'CPA',
  REVENUE_SHARE: 'REVENUE_SHARE',
  HYBRID: 'HYBRID',
} as const satisfies Record<string, CommissionType | AffiliateCommissionType>;
